module.exports = __webpack_public_path__ + "static/media/verticalbanner-01.e1070b1c.png";